import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaBriefcase, FaCommentDots } from 'react-icons/fa';
import { QRCodeCanvas } from 'qrcode.react';
import './CtaMapSection.css';

const SITE_URL = process.env.REACT_APP_SITE_URL || window.location.origin;

const CtaMapSection = () => {
  return (
    <section className="cta-section">
      <div className="cta-container">
        {/* Sol - İş Başvurusu */}
        <div className="cta-card cta-card--primary">
          <div className="cta-card-icon-bg">
            <FaBriefcase />
          </div>
          <div className="cta-card-inner">
            <div className="cta-card-content">
              <h3 className="cta-card-title">Ekibimize katılmak ister misiniz?</h3>
              <p className="cta-card-desc">
                İş başvurusu yapmak için QR kodu taratabilir
                veya butona <span className="cta-highlight">tıklayabilirsiniz!</span>
              </p>
              <Link to="/is-basvurusu" className="cta-btn">
                İş Başvurusu Yap <FaArrowRight />
              </Link>
            </div>
            <div className="cta-qr">
              <div className="cta-qr-real">
                <QRCodeCanvas
                  value={`${SITE_URL}/is-basvurusu`}
                  size={120}
                  bgColor="transparent"
                  fgColor="rgba(255,255,255,0.85)"
                  level="M"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Sağ - Öneri / Şikayet */}
        <div className="cta-card cta-card--accent">
          <div className="cta-card-icon-bg">
            <FaCommentDots />
          </div>
          <div className="cta-card-inner">
            <div className="cta-card-content">
              <h3 className="cta-card-title">Görüşleriniz bizim için değerli!</h3>
              <p className="cta-card-desc">
                Her türlü öneri, memnuniyet ve şikayet talepleriniz için QR kodu taratabilir
                veya butona <span className="cta-highlight">tıklayabilirsiniz!</span>
              </p>
              <Link to="/gorus-bildir" className="cta-btn">
                Görüş Bildir <FaArrowRight />
              </Link>
            </div>
            <div className="cta-qr">
              <div className="cta-qr-real">
                <QRCodeCanvas
                  value={`${SITE_URL}/gorus-bildir`}
                  size={120}
                  bgColor="transparent"
                  fgColor="rgba(255,255,255,0.85)"
                  level="M"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaMapSection;
